import { render, staticRenderFns } from "./WhereShipment.vue?vue&type=template&id=045d5a70&scoped=true"
import script from "./WhereShipment.vue?vue&type=script&lang=ts"
export * from "./WhereShipment.vue?vue&type=script&lang=ts"
import style0 from "./WhereShipment.vue?vue&type=style&index=0&id=045d5a70&prod&lang=scss&scoped=true"
import style1 from "./WhereShipment.vue?vue&type=style&index=1&id=045d5a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d5a70",
  null
  
)

export default component.exports